import { useQuery } from "@tanstack/react-query";
import type { User } from "@/types/auth";
import type { ApiSuccess } from "@/types/api";
import { fetchWithCsrf } from "@/lib/api";

export const CURRENT_USER_QUERY_KEY = ["currentUser"] as const;

interface CurrentUserResponse {
  user: User;
}

export function useCurrentUser() {
  return useQuery<User | null>({
    queryKey: CURRENT_USER_QUERY_KEY,
    queryFn: async () => {
      try {
        const result = await fetchWithCsrf<ApiSuccess<CurrentUserResponse>>(
          "/api/current_user"
        );
        return result.data.user;
      } catch {
        return null;
      }
    },
    retry: (failureCount, error: unknown) => {
      // Don't retry on 401 (unauthenticated)
      if (
        typeof error === "object" &&
        error !== null &&
        "status" in error &&
        (error as { status: number }).status === 401
      ) {
        return false;
      }
      return failureCount < 3;
    },
  });
}
